"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewHeader = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../../../hooks/useTranslations");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Search Preview header component. This component is used to display the search query.
 */
const SearchPreviewHeader = ({
  query
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_HEADER),
    fontWeight: "bold",
    variant: "h6",
    component: "h6",
    color: "textPrimary",
    children: `${translations.popularSearchQueries} ”${(query ?? '').trim()}”`
  });
};
exports.SearchPreviewHeader = SearchPreviewHeader;
//# sourceMappingURL=SearchPreviewHeader.js.map